import { Breadcrumb, Button } from "antd";
import OprationResult from "../../../auxiliary/opration/opration";
import { Content } from "antd/es/layout/layout";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import { complexDigitToman, convertToJalaliWithTime, formatMsisdn, formatTime } from "../../../../tools/tools";
import "../ep.scss";
import "./epFinal.scss";
import Profile from "../../../corporate_subscriber_search/corporate/profile/profile";
const EPFinal = () => {
	const [t] = useTranslation("global");
	const location = useLocation();

	return (
		<>
			<div className="container-main container-sp">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("extraPackage.title") }]}
					/>
					<div className="title-page">
						<h3>{t("extraPackage.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							{location?.state?.purchase && (
								<>
									<Profile Profile={location?.state?.purchase} state />
									<br />
								</>
							)}
							<div className="g-body-format-page">
								<OprationResult
									isSucess={true}
									list={[
										{
											label: "تاریخ و ساعت",
											value: (
												<span dir="ltr">
													{convertToJalaliWithTime(new Date().toISOString())} - {formatTime(new Date())}
												</span>
											),
										},
										{
											label: "نوع سرویس",
											value: <>خرید بسته</>,
										},
										{
											label: "شماره سیم کارت",
											value: <span dir="ltr">{formatMsisdn(location?.state?.epmsisdn?.toString())}</span>,
										},
										{
											label: "عنوان بسته",
											value: <span dir="ltr">{location?.state?.packagename}</span>,
										},
										{
											label: "مبلغ بسته",
											value: (
												<>
													<span dir="ltr">{complexDigitToman(location?.state?.amount)}</span> تومان
												</>
											),
										},
										{
											label: "کد پیگیری",
											value: <span dir="ltr">{location?.state?.eppurchasefollowupcode}</span>,
										},
									]}
								/>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-print" onClick={() => window.print()} type="default" icon={<i className="icon-print"></i>}>
										چاپ فاکتور
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default EPFinal;
